import React, { ReactElement } from 'react';
import ActionButton from '../action-button/action-button.component';
import ArrowUpIcon from '../../icons/arrow-up-icon';
import ArrowDownIcon from '../../icons/arrow-down-icon';

const ExpandButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    onClick,
    ...custom
  } = props;

  return (
    <ActionButton
      withSmallPadding
      onClick={onClick}
      {...custom}
    >
      {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}
    </ActionButton>
  );
});

export default ExpandButton;
